import { Fragment } from 'react';

/**
 * @deprecated
 * ### Description
 * `Repeat` has been deprecated and replaced by Classify `Repeat`.
 *
 * ### Example
 * ```
 * import Repeat from '@classify/react-core-components/Repeat';
 * ```
 */
export default function Repeat({ children, count = 1 }) {
  return (
    <>
      {Array(Math.max(0, count))
        .fill(null)
        .map((_, rowIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={rowIndex}>{children}</Fragment>
        ))}
    </>
  );
}
